import {GuideTourStep} from "../../../search/constants/GuideTourStep";

export const offerListGuideTourName = "offerListGuideTour";

export const offerListGuideTourSteps = [{id: GuideTourStep.SELECT_DISTRICTS}, {id: GuideTourStep.SELECT_FILTERS}];
